import * as Factory from 'factory.ts'
import faker from 'faker'

import { type TaxApiModel } from '../TaxApiModel'

export const TaxApiModelStub = Factory.Sync.makeFactory<TaxApiModel>({
  id: Factory.each(() => faker.random.number()),
  description: Factory.each(() => faker.finance.currencyCode()),
  is_active: true,
  is_default: false,
  is_inclusive: false,
  name: Factory.each(() => faker.finance.currencyCode()),
  percentage: Factory.each(() => (faker.random.number(100) / 100).toString()),
})
